console.log("Ready CustomJS");

// Fix: las imágenes .webp del mini cart no cargaban porque
// Shopify.Image.getSizedImageUrl (option_selection.js legacy) retorna null
// para extensiones que no sean jpg/png/gif. Se reemplaza el formatter de
// CartJS usando el parámetro width del CDN, compatible con todos los formatos.
(function () {
    if (!window.rivets || !rivets.formatters) return;

    var widthBySizeName = { pico: 16, icon: 32, thumb: 50, small: 100, compact: 160, medium: 240, large: 480, grande: 600 };

    function productImageSizeFormatter(imageUrl, sizeName) {
        if (!imageUrl) return 'https://cdn.shopify.com/s/images/admin/no-image-large.gif';
        var imageWidth = (widthBySizeName[sizeName] || 100) * 2; // 2x para pantallas retina
        var separator = imageUrl.indexOf('?') === -1 ? '?' : '&';
        return imageUrl + separator + 'width=' + imageWidth;
    }

    rivets.formatters.product_image_size = productImageSizeFormatter;
    rivets.formatters.productImageSize = productImageSizeFormatter;
})();
var serachElements = document.querySelectorAll('.hdicon.search-icn'); // Elementos con la clase "hdicon search-icn"
var hdiconElements = document.querySelectorAll(".hdicon.header-cart"); // Elementos con la clase "hdicon header-cart"
var elementsClose = document.querySelectorAll('.closeSearch'); // Elementos con la clase "closeSearch"
var statusBtnHdicon = false;

(function () {
    const originalCreateElement = document.createElement;

    document.createElement = function (tagName, ...args) {
        const el = originalCreateElement.call(document, tagName, ...args);

        if (tagName.toLowerCase() === 'script') {
            const originalSetAttribute = el.setAttribute;
            el.setAttribute = function (name, value) {
                if (name === 'src' && value.includes("handlebars.js/4.0.5/")) {
                    var s = document.createElement("script");
                    s.src = "//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.7.8/handlebars.min.js";
                    document.head.appendChild(s);
                    return;
                }
                return originalSetAttribute.call(this, name, value);
            };
        }
        return el;
    };
})();

document.addEventListener('click', function(event) {
    let cartDrawer = document.getElementById("cartDrawer");
    let hdiconElements = document.querySelectorAll(".hdicon.header-cart");

    // Verificar si el clic no ocurrió dentro del elemento
    if (!cartDrawer.contains(event.target)) {

        // Iterar sobre todos los elementos con la clase 'hdicon' y 'header-cart'
        hdiconElements.forEach(function(element) {

            // Quitar la clase "borderBottom"
            element.classList.remove("borderBottom");
        });
    }
});

// Agrega un escuchador de eventos a cada elemento
hdiconElements.forEach(function(element) {
    element.addEventListener("click", function() {

        if (!statusBtnHdicon) {
            // Agregar la clase "borderBottom"
            element.classList.add("borderBottom");
            statusBtnHdicon = true;
        } else {
            // Quitar la clase "borderBottom"
            element.classList.toggle("borderBottom");
            statusBtnHdicon = false;
        }
    });
});

// Agrega un escuchador de eventos a cada elemento
serachElements.forEach(function(element) {
    element.addEventListener("click", function() {
        let modalOverly = document.querySelector(".modalOverly");

        // Quitar la clase "borderBottom"
        element.classList.add("borderBottom");
        // Cambiar estilo
        modalOverly.style.display = "none";
        
    });
});

// Agrega un escuchador de eventos a cada elemento 
elementsClose.forEach(function(element) {
    element.addEventListener("click", function() {

        // Para los botones de busqueda
        serachElements.forEach(function(element2) {

            // Quitar la clase "borderBottom"
            element2.classList.remove("borderBottom");
        });
    });
});


// Función para manejar el cambio de tamaño del div
function handleResize(entries) {
    entries.forEach(entry => {
        const target = entry.target;
        // console.log('El Alto es:');
        // console.log(target.offsetHeight);

        // Capturo el carrito desplegable
        let cartDrawer = document.getElementById("cartDrawer");

        // Cambiar estilo
        // if (target.offsetHeight === 60) {
        //     cartDrawer.style.top = "112px";
        // } else if (target.offsetHeight === 100) {
        //     cartDrawer.style.top = "135px";
        // } else if (target.offsetHeight === 90) {
        //     cartDrawer.style.top = "128px";
        // } else if (target.offsetHeight === 70) {
        //     cartDrawer.style.top = "118px";
        // }
    });
}

// Configurar el observer para observar cambios en el tamaño del div
const observer = new ResizeObserver(handleResize);
const headerSelect = selectHeader()

// Iniciar la observación del div
observer.observe(headerSelect);

// También puedes ejecutar la función al cargar la página para obtener el tamaño inicial
window.addEventListener('load', () => handleResize([{ target: headerSelect }]));

function selectHeader() {
    let headerId = document.getElementById('header0');

    if (headerId == null) {
        headerId = document.getElementById('header1');
        if (headerId == null) {
            headerId = document.getElementById('header2');
            if (headerId == null) {
                headerId = document.getElementById('header3');
                if (headerId == null) {
                    headerId = document.getElementById('header4');
                    if (headerId == null) {
                        headerId = document.getElementById('header5');
                    } else {
                        headerId = null;
                    }
                }
            }
        }
    }

    return headerId;
}

document.addEventListener('DOMContentLoaded', function() {
    // Buscar el elemento <li> con la clase .active
    let activeListItem = document.querySelector('.blog_detail .pagination ul .active');
    
    // Verificar si se encontró el elemento
    if (activeListItem) {
        // Crear un nuevo elemento <li> con la clase .separatorSlash
        let separatorSlashItem = document.createElement('li');
        separatorSlashItem.className = 'separatorSlash';
    
        // Crear un nuevo elemento <p> con el texto "/"
        let slashElement = document.createElement('p');
        slashElement.textContent = '/';
    
        // Agregar el elemento <p> al elemento <li>
        separatorSlashItem.appendChild(slashElement);
    
        // Insertar el nuevo elemento <li> después del elemento <li> con la clase .active
        activeListItem.parentNode.insertBefore(separatorSlashItem, activeListItem.nextSibling);
    }

});

// Actualizar color
function updateSliderColor() {
    // input conn el rango
    let inputRange = document.getElementById('inputRangeMiniCart');
    let percentage = (inputRange.value - inputRange.min) / (inputRange.max - inputRange.min) * 100;
    let colorStop = percentage + '%';

    // Color para el rango
    const colorRangeDiv = document.getElementById('colorRange');
    const backgroundColor = window.getComputedStyle(colorRangeDiv).backgroundColor;

    // Actualizo el rango del color
    inputRange.style.background = `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundColor} ${colorStop}, #fff ${colorStop}, #fff 100%)`;
}

// Ejecutar la función
updateSliderColor();


// Seleccionar el span que quieres observar
const targetSpan = document.getElementById('valueTotalMiniCart');

// Crear una instancia de MutationObserver y especificar la función de devolución de llamada
const observerSpanMiniCart = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        // Se ejecutará cuando haya cambios en el contenido del span
        let stringPrice = targetSpan.textContent;
        let totalPrice = parseInt(stringPrice.replace(/\D/g, ''), 10);
        
        let inputRange = document.getElementById('inputRangeMiniCart');
        inputRange.value = totalPrice;
        
        // console.log(targetSpan.textContent);
        // console.log(totalPrice);
        
        updateSliderColor();
    });
});

// Configurar y comenzar a observar el span
const config = { childList: true, subtree: true };
observerSpanMiniCart.observe(targetSpan, config);


// Cambiar 0 por 1 y (letras o simbolos) por 1
function changeZeroToOne(input) {
    // Obtener el valor actual del input
    let value = input.value;

    if (value === "0") {
        // Reemplazar todos los 0 por 1
        value = value.replace(/0/g, '1');
    }

    // Reemplazar caracteres no numéricos por 1
    value = value.replace(/\D/g, '1');
    
    // Establecer el nuevo valor en el input
    input.value = value;
}